var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagPakistan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15671_193962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 1H1V19H28V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 1H7.75V19H28V1Z",
    fill: "#01411C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8766 15.4C20.8589 15.4 23.2766 12.9823 23.2766 9.99998C23.2766 7.01764 20.8589 4.59998 17.8766 4.59998C14.8942 4.59998 12.4766 7.01764 12.4766 9.99998C12.4766 12.9823 14.8942 15.4 17.8766 15.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5425 12.4727C24.5858 10.6564 24.7698 7.52769 22.9536 5.48441C21.1373 3.44114 18.0086 3.25709 15.9653 5.07334C13.922 6.88958 13.738 10.0183 15.5542 12.0616C17.3705 14.1049 20.4992 14.2889 22.5425 12.4727Z",
    fill: "#01411C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8457 5.95923L22.1203 8.51821L18.776 7.78496L21.9126 6.41241L20.1818 9.3665L19.8457 5.95923Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15671_193962"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPakistan);
export default __webpack_public_path__ + "static/media/FlagPakistan.74e6f3b3b8dbad41528a36a273f2e4be.svg";
export { ForwardRef as ReactComponent };